import React, { useState, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { leerArchivo, validarColumnas, contarInvalidos, subir, descargarFallos, COLUMNAS } from '../../servicios/CargaConsulta';
import './cargarconsulta.css';

const EXTENSIONES = ['.csv', '.xlsx', '.xls'];

export default function CargarConsulta() {
    const [tipo, setTipo] = useState('post');
    const [archivo, setArchivo] = useState(null);
    const [filas, setFilas] = useState(null);
    const [invalidosPrevios, setInvalidosPrevios] = useState(0);
    const [estado, setEstado] = useState('inicial');
    const [progreso, setProgreso] = useState(null);
    const [arrastrando, setArrastrando] = useState(false);
    const inputRef = useRef(null);

    const procesar = async (file) => {
        if (!file) return;
        const nombre = file.name.toLowerCase();
        if (!EXTENSIONES.some((e) => nombre.endsWith(e))) {
            toast.error(`Formato no válido. Debe ser ${EXTENSIONES.join(', ')}.`); return;
        }
        setArchivo(file); setFilas(null); setInvalidosPrevios(0); setEstado('inicial');
        try {
            const { headers, filas } = await leerArchivo(file);
            const err = validarColumnas(headers, tipo);
            if (err) { toast.error(err, { autoClose: 8000 }); setArchivo(null); if (inputRef.current) inputRef.current.value=''; return; }
            if (filas.length === 0) { toast.warn('El archivo no tiene filas.'); setArchivo(null); return; }
            const malos = contarInvalidos(filas);
            setInvalidosPrevios(malos);
            if (malos === filas.length) { toast.error('Ningún teléfono tiene formato válido (09XXXXXXXX).', { autoClose: 7000 }); setArchivo(null); return; }
            if (malos > 0) toast.warn(`${malos} de ${filas.length} se omitirán por teléfono inválido.`, { autoClose: 6000 });
            setFilas(filas); setEstado('listo');
            toast.success(`Archivo válido: ${filas.length.toLocaleString()} registros.`);
        } catch (ex) { toast.error(ex.message); setArchivo(null); }
    };

    const onArchivo = (e) => procesar(e.target.files[0]);
    const onDrop = (e) => { e.preventDefault(); setArrastrando(false); if (estado !== 'subiendo') procesar(e.dataTransfer.files?.[0]); };

    const iniciar = async () => {
        if (!filas) return;
        setEstado('subiendo');
        setProgreso({ procesadas: 0, insertadas: 0, actualizadas: 0, invalidas: 0, totalFilas: filas.length });
        try {
            const res = await subir(filas, tipo, setProgreso);
            setProgreso(res); setEstado('fin'); toast.success('Carga completada');
        } catch (ex) { toast.error('Error: ' + ex.message); setEstado('listo'); }
    };

    const reiniciar = () => { setArchivo(null); setFilas(null); setEstado('inicial'); setProgreso(null); setInvalidosPrevios(0); if (inputRef.current) inputRef.current.value=''; };

    const pct = progreso && progreso.totalFilas ? Math.round((progreso.procesadas / progreso.totalFilas) * 100) : 0;

    return (
        <div className="cc-wrap">
            <ToastContainer position="top-right" autoClose={4000} />
            <div className="cc-card">
                <h2 className="cc-title">Cargar base de consulta (Fusión)</h2>
                <p className="cc-sub">Sube la base <strong>PRE</strong> o <strong>POST</strong> de Claro a su base de consulta aislada. Se actualiza por teléfono; no duplica.</p>

                {estado !== 'fin' && (
                    <>
                        <div className="cc-tipo">
                            <span className="cc-tipo__label">Tipo de base:</span>
                            <div className="cc-tipo__ops">
                                <button className={`cc-tipo__op ${tipo==='pre'?'activo':''}`} onClick={()=>{setTipo('pre');reiniciar();}} disabled={estado==='subiendo'}>PRE Claro</button>
                                <button className={`cc-tipo__op ${tipo==='post'?'activo':''}`} onClick={()=>{setTipo('post');reiniciar();}} disabled={estado==='subiendo'}>POST Claro</button>
                            </div>
                            <small className="cc-cols">Columnas: {COLUMNAS[tipo].join(', ')}</small>
                        </div>

                        <div className={`cc-drop ${arrastrando?'arrastrando':''}`}
                             onDragOver={(e)=>{e.preventDefault();if(estado!=='subiendo')setArrastrando(true);}}
                             onDragLeave={(e)=>{e.preventDefault();setArrastrando(false);}}
                             onDrop={onDrop}>
                            <input ref={inputRef} type="file" accept=".csv,.xlsx,.xls" id="cc-file" className="cc-input" onChange={onArchivo} disabled={estado==='subiendo'} />
                            <label htmlFor="cc-file" className="cc-label">
                                <i className="bi bi-database-add"></i>
                                <span>{archivo ? archivo.name : 'Arrastra el archivo aquí o haz clic'}</span>
                                <small>Excel o CSV</small>
                            </label>
                        </div>
                    </>
                )}

                {estado === 'listo' && (
                    <div className="cc-listo">
                        <p><strong>{filas.length.toLocaleString()}</strong> registros listos{invalidosPrevios>0 && <span className="cc-aviso"> ({invalidosPrevios} se omitirán)</span>}.</p>
                        <button className="cc-btn" onClick={iniciar}>Subir a {tipo.toUpperCase()}</button>
                    </div>
                )}

                {estado === 'subiendo' && progreso && (
                    <div className="cc-prog">
                        <div className="cc-bar"><div className="cc-bar__fill" style={{width:pct+'%'}} /></div>
                        <p>{progreso.procesadas.toLocaleString()} / {progreso.totalFilas.toLocaleString()} ({pct}%)</p>
                    </div>
                )}

                {estado === 'fin' && progreso && (
                    <div className="cc-res">
                        <h3>Resumen — {tipo.toUpperCase()} Claro</h3>
                        <div className="cc-stat cc-ok"><span>Nuevos</span><strong>{progreso.insertadas.toLocaleString()}</strong></div>
                        <div className="cc-stat cc-upd"><span>Actualizados</span><strong>{progreso.actualizadas.toLocaleString()}</strong></div>
                        <div className="cc-stat cc-bad"><span>Inválidos</span><strong>{progreso.invalidas.toLocaleString()}</strong></div>
                        {progreso.invalidas>0 && progreso.fallos && (
                            <button className="cc-btn cc-btn--desc" onClick={()=>descargarFallos(progreso.fallos, tipo)}><i className="bi bi-download"></i> Descargar fallos ({progreso.invalidas})</button>
                        )}
                        <button className="cc-btn cc-btn--sec" onClick={reiniciar}>Cargar otra base</button>
                    </div>
                )}
            </div>
        </div>
    );
}
